export const PRIMARY: string = "#F4A60F";
export const SPINNER_COLOR = '#F4A60F'
export const PRODUCT_SKELETON_COLOR = "#ddd"